import {
    GET_QUESTIONS,
    GET_QUESTIONS_SUCCESS,
    GET_QUESTIONS_FAILURE,
    UPDATE_QUESTION_STATUS,
    UPDATE_QUESTION_STATUS_SUCCESS,
    UPDATE_QUESTION_STATUS_FAILURE,
    DELETE_QUESTION,
    DELETE_QUESTION_SUCCESS,
    DELETE_QUESTION_FAILURE,
    ADD_QUESTION,
    ADD_QUESTION_SUCCESS,
    ADD_QUESTION_FAILURE,
    GET_QUESTION_DETAILS,
    GET_QUESTION_DETAILS_SUCCESS,
    GET_QUESTION_DETAILS_FAILURE,
    IMPORT_QUESTIONS_DATA,
    IMPORT_QUESTIONS_DATA_SUCCESS,
    IMPORT_QUESTIONS_DATA_FAILURE,
    EDIT_QUESTION,
    EDIT_QUESTION_SUCCESS,
    EDIT_QUESTION_FAILURE,
} from "../Constants"

export const GetQuestions = (payload) => ({
    type: GET_QUESTIONS,
    payload
});

export const GetQuestionsSuccess = (payload) => ({
    type: GET_QUESTIONS_SUCCESS,
    payload
});

export const GetQuestionsFailure = (payload) => ({
    type: GET_QUESTIONS_FAILURE,
    payload
});

export const EditQuestions = (payload) => ({
    type: EDIT_QUESTION,
    payload
});

export const EditQuestionsSuccess = (payload) => ({
    type: EDIT_QUESTION_SUCCESS,
    payload
});

export const EditQuestionsFailure = (payload) => ({
    type: EDIT_QUESTION_FAILURE,
    payload
});

export const UpdateQuestionStatus = (payload) => ({
    type: UPDATE_QUESTION_STATUS,
    payload
});

export const UpdateQuestionStatusSuccess = (payload) => ({
    type: UPDATE_QUESTION_STATUS_SUCCESS,
    payload
});

export const UpdateQuestionStatusFailure = (payload) => ({
    type: UPDATE_QUESTION_STATUS_FAILURE,
    payload
});

export const DeleteQuestion = (payload) => ({
    type: DELETE_QUESTION,
    payload
});

export const DeleteQuestionSuccess = (payload) => ({
    type: DELETE_QUESTION_SUCCESS,
    payload
});

export const DeleteQuestionFailure = (payload) => ({
    type: DELETE_QUESTION_FAILURE,
    payload
});

export const AddQuestion = (payload) => ({
    type: ADD_QUESTION,
    payload
});

export const AddQuestionSuccess = (payload) => ({
    type: ADD_QUESTION_SUCCESS,
    payload
});

export const AddQuestionFailure = (payload) => ({
    type: ADD_QUESTION_FAILURE,
    payload
});

export const GetQuestionDetails = (payload) => ({
    type: GET_QUESTION_DETAILS,
    payload
});

export const GetQuestionDetailsSuccess = (payload) => ({
    type: GET_QUESTION_DETAILS_SUCCESS,
    payload
});

export const GetQuestionDetailsFailure = (payload) => ({
    type: GET_QUESTION_DETAILS_FAILURE,
    payload
});

export const ImportData = (payload) => ({
    type: IMPORT_QUESTIONS_DATA,
    payload
});

export const ImportDataSuccess = (payload) => ({
    type: IMPORT_QUESTIONS_DATA_SUCCESS,
    payload
});

export const ImportDataFailure = (payload) => ({
    type: IMPORT_QUESTIONS_DATA_FAILURE,
    payload
});